import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";

import { fetchfreelancerProfile } from "../../../redux/features/find-a-job/actions/authAction";
import Loader from "../../../components/loader";
import { getProfile } from "../../../utils/pip";

const Profile = () => {
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const profileData = getProfile("freelancer");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchfreelancerProfile());
  }, []);

  if (subLoading) {
    return <Loader />;
  }
  return (
    <>
      <CoachMenuLayout>
        <div className="ct_px_40 my-5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-6 mb-4 mb-xl-0">
                <div>
                  <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20">
                    <div className="d-flex align-items-center gap-3 ct_flex_col_575 ">
                      <div className="ct_profile_pic ct_flex_shrink_0">
                        <img src="../assets/img/Avatar_11_big.png" />
                      </div>
                      <div className="ct_flex_1">
                        <div className="d-flex align-items-center gap-3 justify-content-between mb-3 ">
                          <div>
                            <h4 className="ct_fs_20 ct_darkblue_text mb-2">
                              {`${profileData?.first_name} ${profileData?.last_name}`}
                            </h4>
                            <p className="ct_fs_14 ct_darkblue_text mb-0">
                              <i class="fa-solid fa-location-dot"></i>{" "}
                              {profileData?.open_talent?.location | "#N/A"}
                            </p>
                          </div>
                          <div>
                            <a className="ct_yellow_btn ct_sky_blue_btn ct_h_32 ct_white_nowrap">
                              Edit Profile
                            </a>
                          </div>
                        </div>
                        <p className="ct_para_scroll ct_custom_scroll ct_grey_text">
                          {profileData?.open_talent?.bio || ""}

                          {/* I am a UI/UX designer passionate about crafting
                        intuitive, user friendly digital experiences that drive
                        real impact. I blend strategy with creativity to ...{" "}
                        <span className="ct_darksky_blue_text">MORE</span> */}
                        </p>
                        <ul>
                          <li className="d-flex align-items-center gap-2">
                            <img src="../assets/img/grey_mail_icon.svg" />
                            {profileData?.email || ""}
                          </li>
                          {/* <li className="d-flex align-items-center gap-2 mt-1">
                          <img src="../assets/img/grey_phon_icon.svg" />
                          1234567891
                        </li> */}
                        </ul>
                      </div>
                    </div>

                    <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_40">
                      <li>
                        <div className="d-flex align-items-center gap-2">
                          <img src="../assets/img/tabler_clock.svg" />
                          <div>
                            <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                              5+ Years Job
                            </h4>
                            <p className="ct_fs_14 ct_grey_text mb-0">
                              Experienced
                            </p>
                          </div>
                        </div>
                      </li>
                      {profileData?.open_talent?.certificates?.length > 0 && (
                        <li>
                          <div className="d-flex align-items-center gap-2">
                            <img src="../assets/img/hugeicons_award-01.svg" />
                            <div>
                              <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                                {profileData?.open_talent?.certificates
                                  ?.length || ""}{" "}
                                Certificate
                                {profileData?.open_talent?.certificates
                                  ?.length > 1
                                  ? "s"
                                  : ""}
                              </h4>
                              <p className="ct_fs_14 ct_grey_text mb-0">
                                Advanced
                              </p>
                            </div>
                          </div>
                        </li>
                      )}
                      <li>
                        <div className="d-flex align-items-center gap-2">
                          <img src="../assets/img/hugeicons_job-link.svg" />
                          <div>
                            <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                              4 Internship
                            </h4>
                            <p className="ct_fs_14 ct_grey_text mb-0">
                              Completed
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20 ct_mt_40">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                      <p className="ct_fs_16 mb-0 ct_orange_text">
                        My Approach to Coaching
                      </p>
                      <div className="ct_cursor_pointer">
                        <svg
                          width="11"
                          height="11"
                          viewBox="0 0 11 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 10.5V8.02083L7.7 0.335417C7.81667 0.228472 7.94558 0.145833 8.08675 0.0875001C8.22792 0.0291667 8.37608 0 8.53125 0C8.68642 0 8.83711 0.0291667 8.98333 0.0875001C9.12955 0.145833 9.25594 0.233333 9.3625 0.35L10.1646 1.16667C10.2812 1.27361 10.3664 1.4 10.4201 1.54583C10.4738 1.69167 10.5004 1.8375 10.5 1.98333C10.5 2.13889 10.4734 2.28725 10.4201 2.42842C10.3668 2.56958 10.2816 2.69831 10.1646 2.81458L2.47917 10.5H0ZM8.51667 2.8L9.33333 1.98333L8.51667 1.16667L7.7 1.98333L8.51667 2.8Z"
                            fill="#023047"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      className="ct_para_scroll ct_custom_scroll ct_darkblue_text ct_fs_12"
                      style={{ maxWidth: "541px" }}
                    >
                      Over the last 6 years, I’ve supported business owners,
                      creatives, and visionaries in building simple, strategic
                      paths to success.
                    </p>
                    <p
                      className="ct_para_scroll ct_custom_scroll ct_darkblue_text ct_fs_12"
                      style={{ maxWidth: "541px" }}
                    >
                      My coaching blends business strategy with mindset work
                      because I believe clarity isn’t just about the next step,
                      it’s about how you feel taking it. Whether you're stuck,
                      starting fresh, or scaling an idea that won’t quit, I’m
                      here to help you move forward with purpose.
                    </p>
                  </div>
                </div>

                <div className="ct_outline_bg h-auto ct_border_radius_10 ct_p_20 ct_mt_40">
                  <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                    <p className="ct_fs_16 mb-0 ct_orange_text">
                      Certification{" "}
                    </p>
                    <div className="ct_cursor_pointer">
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 11 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 10.5V8.02083L7.7 0.335417C7.81667 0.228472 7.94558 0.145833 8.08675 0.0875001C8.22792 0.0291667 8.37608 0 8.53125 0C8.68642 0 8.83711 0.0291667 8.98333 0.0875001C9.12955 0.145833 9.25594 0.233333 9.3625 0.35L10.1646 1.16667C10.2812 1.27361 10.3664 1.4 10.4201 1.54583C10.4738 1.69167 10.5004 1.8375 10.5 1.98333C10.5 2.13889 10.4734 2.28725 10.4201 2.42842C10.3668 2.56958 10.2816 2.69831 10.1646 2.81458L2.47917 10.5H0ZM8.51667 2.8L9.33333 1.98333L8.51667 1.16667L7.7 1.98333L8.51667 2.8Z"
                          fill="#023047"
                        />
                      </svg>
                    </div>
                  </div>
                  <ul>
                    <li>
                      <img />
                      <div>
                        <h5 className="ct_fs_14 mb-2">
                          MBA, Strategy & Innovation
                        </h5>
                        <p className="ct_fs_12 ct_darkblue_text mb-2">
                          London Business School{" "}
                        </p>
                        <div className="d-flex align-items-center gap-4">
                          <span className="ct_fs_12">Jan 2017 - 2020</span>
                          <span className="ct_fs_12">3 Yrs</span>
                        </div>
                      </div>
                    </li>
                  </ul>

                  {profileData?.open_talent?.skills?.split(",")?.length > 0 && (
                    <div className="ct_mt_28">
                      <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                        <p className="ct_fs_16 mb-0 ct_orange_text">
                          Coaching type{" "}
                        </p>
                        <div className="ct_cursor_pointer">
                          <svg
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 10.5V8.02083L7.7 0.335417C7.81667 0.228472 7.94558 0.145833 8.08675 0.0875001C8.22792 0.0291667 8.37608 0 8.53125 0C8.68642 0 8.83711 0.0291667 8.98333 0.0875001C9.12955 0.145833 9.25594 0.233333 9.3625 0.35L10.1646 1.16667C10.2812 1.27361 10.3664 1.4 10.4201 1.54583C10.4738 1.69167 10.5004 1.8375 10.5 1.98333C10.5 2.13889 10.4734 2.28725 10.4201 2.42842C10.3668 2.56958 10.2816 2.69831 10.1646 2.81458L2.47917 10.5H0ZM8.51667 2.8L9.33333 1.98333L8.51667 1.16667L7.7 1.98333L8.51667 2.8Z"
                              fill="#023047"
                            />
                          </svg>
                        </div>
                      </div>
                      <ul className="d-flex align-items-center gap-3 flex-wrap cr_para_scroll ct_custom_scroll">
                        {profileData?.open_talent?.skills
                          ?.split(",")
                          ?.map((item, index) => (
                            <li className="mb-2">
                              <span className="ct_shadow_badge">{item}</span>
                            </li>
                          ))}
                        {/* <li className="mb-2">
                        <span className="ct_shadow_badge">UX Writing</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">Flow Chart</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">Flow Chart</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">Web App Design</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">Prototyping</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">Prototyping</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">Mobile Design</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">UI</span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">
                          Responsive Web Design
                        </span>
                      </li>
                      <li className="mb-2">
                        <span className="ct_shadow_badge">
                          Usability Testing
                        </span>
                      </li> */}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="col-xl-6 mb-4 mb-xl-0">
                <div>
                  <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20">
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <h5 className="mb-0 ct_fs_20 ct_darkblue_text">
                        Job Experience
                      </h5>
                      <a
                        className="ct_yellow_link"
                        data-bs-target="#ct_add_experience_modal"
                        data-bs-toggle="modal"
                      >
                        Add More +
                      </a>
                    </div>
                    <ul className="ct_mt_30">
                      <li>
                        <div className="d-flex align-items-start gap-2  ct_flex_col_575 mb-2">
                          <div class="ct_feature_job_icon border-0">
                            <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ct_flex_1 justify-content-between">
                              <div>
                                <h5 className="ct_fs_16 mb-2">
                                  UI/UX Designer
                                </h5>
                                <p className="mb-0 ct_fs_16 ct_grey_text">
                                  CodeNest
                                </p>
                              </div>
                              <div className="d-flex align-items-center gap-5">
                                <p className="d-flex align-items-center gap-2 ct_fs_12">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25C7.20979 2.25 5.4929 2.96116 4.22703 4.22703C2.96116 5.4929 2.25 7.20979 2.25 9Z"
                                      stroke="#535862"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9 5.25V9L10.5 11.5"
                                      stroke="#535862"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Nov 2021 - Dec 2024
                                </p>

                                <p className="d-flex align-items-center gap-2 ct_fs_12">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                      fill="#535862"
                                    />
                                  </svg>
                                  Los Angeles, CA 90045
                                </p>
                              </div>
                            </div>
                            <p
                              className="ct_fs_14 ct_darkblue_text mt-2"
                              style={{ maxWidth: "586px" }}
                            >
                              I led design efforts on web and mobile platforms
                              for client in e-commerce, wellness, and education.
                              I was responsible for creating wireframes, UI
                              kits, and clickable prototypes, and worked closely
                              with development teams to ensure seamless
                              execution.
                            </p>
                            <div className="row">
                              <div className="col-md-6 mb-4 mb-md-0">
                                <div>
                                  <img
                                    src="../assets/img/Rectangle_4214_20.png"
                                    className="ct_img_h_160 ct_border_radius_10"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-4 mb-md-0">
                                <div>
                                  <img
                                    src="../assets/img/Rectangle_4214_21.png"
                                    className="ct_img_h_160 ct_border_radius_10"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_28">
                        <div className="d-flex align-items-start gap-2  ct_flex_col_575 mb-2">
                          <div class="ct_feature_job_icon border-0">
                            <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ct_flex_1 justify-content-between">
                              <div>
                                <h5 className="ct_fs_16 mb-2">
                                  UI/UX Designer
                                </h5>
                                <p className="mb-0 ct_fs_16 ct_grey_text">
                                  CodeNest
                                </p>
                              </div>
                              <div className="d-flex align-items-center gap-5">
                                <p className="d-flex align-items-center gap-2 ct_fs_12">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25C7.20979 2.25 5.4929 2.96116 4.22703 4.22703C2.96116 5.4929 2.25 7.20979 2.25 9Z"
                                      stroke="#535862"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9 5.25V9L10.5 11.5"
                                      stroke="#535862"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Nov 2021 - Dec 2024
                                </p>

                                <p className="d-flex align-items-center gap-2 ct_fs_12">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                      fill="#535862"
                                    />
                                  </svg>
                                  Los Angeles, CA 90045
                                </p>
                              </div>
                            </div>
                            <p
                              className="ct_fs_14 ct_darkblue_text mt-2"
                              style={{ maxWidth: "586px" }}
                            >
                              I led design efforts on web and mobile platforms
                              for client in e-commerce, wellness, and education.
                              I was responsible for creating wireframes, UI
                              kits, and clickable prototypes, and worked closely
                              with development teams to ensure seamless
                              execution.
                            </p>
                            <div className="row">
                              <div className="col-md-6 mb-4 mb-md-0">
                                <div>
                                  <img
                                    src="../assets/img/Rectangle_4214_25.png"
                                    className="ct_img_h_160 ct_border_radius_10"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-4 mb-md-0">
                                <div>
                                  <img
                                    src="../assets/img/Rectangle_4214_26.png"
                                    className="ct_img_h_160 ct_border_radius_10"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_28">
                        <div className="d-flex align-items-start gap-2  ct_flex_col_575 mb-2">
                          <div class="ct_feature_job_icon border-0">
                            <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ct_flex_1 justify-content-between">
                              <div>
                                <h5 className="ct_fs_16 mb-2">
                                  UI/UX Designer
                                </h5>
                                <p className="mb-0 ct_fs_16 ct_grey_text">
                                  CodeNest
                                </p>
                              </div>
                              <div className="d-flex align-items-center gap-5">
                                <p className="d-flex align-items-center gap-2 ct_fs_12">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25C7.20979 2.25 5.4929 2.96116 4.22703 4.22703C2.96116 5.4929 2.25 7.20979 2.25 9Z"
                                      stroke="#535862"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9 5.25V9L10.5 11.5"
                                      stroke="#535862"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Nov 2021 - Dec 2024
                                </p>

                                <p className="d-flex align-items-center gap-2 ct_fs_12">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                      fill="#535862"
                                    />
                                  </svg>
                                  Los Angeles, CA 90045
                                </p>
                              </div>
                            </div>
                            <p
                              className="ct_fs_14 ct_darkblue_text mt-2"
                              style={{ maxWidth: "586px" }}
                            >
                              I led design efforts on web and mobile platforms
                              for client in e-commerce, wellness, and education.
                              I was responsible for creating wireframes, UI
                              kits, and clickable prototypes, and worked closely
                              with development teams to ensure seamless
                              execution.
                            </p>
                            <div className="row">
                              <div className="col-md-6 mb-4 mb-md-0">
                                <div>
                                  <img
                                    src="../assets/img/Rectangle_4214_27.png"
                                    className="ct_img_h_160 ct_border_radius_10"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-4 mb-md-0">
                                <div>
                                  <img
                                    src="../assets/img/Rectangle_4214_28.png"
                                    className="ct_img_h_160 ct_border_radius_10"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20 ct_mt_20">
                    <div className="row">
                      <div className="col-md-10 mx-auto">
                        <div className="text-center p-3">
                          <svg
                            width="75"
                            height="75"
                            viewBox="0 0 75 75"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.5 2.08333C12.5 1.5308 12.7195 1.0009 13.1102 0.610195C13.5009 0.219494 14.0308 0 14.5833 0H60.4167C60.9692 0 61.4991 0.219494 61.8898 0.610195C62.2805 1.0009 62.5 1.5308 62.5 2.08333V4.16667H72.9167C73.4692 4.16667 73.9991 4.38616 74.3898 4.77686C74.7805 5.16756 75 5.69747 75 6.25V18.75C75 21.5127 73.9025 24.1622 71.949 26.1157C69.9955 28.0692 67.346 29.1667 64.5833 29.1667H61.0771C59.5874 33.3686 57.0029 37.0967 53.5907 39.9659C50.1784 42.835 46.062 44.7412 41.6667 45.4875V58.3333H54.1667C54.7192 58.3333 55.2491 58.5528 55.6398 58.9435C56.0305 59.3342 56.25 59.8641 56.25 60.4167V72.9167C56.25 73.4692 56.0305 73.9991 55.6398 74.3898C55.2491 74.7805 54.7192 75 54.1667 75H20.8333C20.2808 75 19.7509 74.7805 19.3602 74.3898C18.9695 73.9991 18.75 73.4692 18.75 72.9167V60.4167C18.75 59.8641 18.9695 59.3342 19.3602 58.9435C19.7509 58.5528 20.2808 58.3333 20.8333 58.3333H33.3333V45.4875C28.938 44.7412 24.8216 42.835 21.4093 39.9659C17.9971 37.0967 15.4126 33.3686 13.9229 29.1667H10.4167C7.65399 29.1667 5.00447 28.0692 3.05097 26.1157C1.09747 24.1622 0 21.5127 0 18.75V6.25C0 5.69747 0.219494 5.16756 0.610195 4.77686C1.0009 4.38616 1.5308 4.16667 2.08333 4.16667H12.5V2.08333ZM62.5 20.8333V8.33333H70.8333V18.75C70.8333 20.4076 70.1749 21.9973 69.0027 23.1694C67.8306 24.3415 66.2409 25 64.5833 25H62.5V20.8333ZM12.5 8.33333H4.16667V18.75C4.16667 20.4076 4.82515 21.9973 5.99725 23.1694C7.16935 24.3415 8.75906 25 10.4167 25H12.5V8.33333Z"
                              fill="#FFB703"
                            />
                          </svg>
                        </div>
                        <div>
                          <h4 className="ct_fs_28 ct_darkblue_text text-center mt-0 mb-3">
                            Upgrade to Pro{" "}
                          </h4>
                          <p className="ct_darkblue_text text-center">
                            Get more visibility, better opportunities and growth
                            support
                          </p>
                          <ul>
                            <li className="ct_fs_14 ct_darkblue_text d-flex align-items-center gap-2">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                  fill="#8ECAE6"
                                />
                                <path
                                  d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                  fill="white"
                                />
                              </svg>
                              NuGlow - Kickstart your journey with curated jobs
                              and profile visibility
                            </li>
                            <li className="ct_fs_14 ct_darkblue_text mt-2 d-flex align-items-center gap-2">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                  fill="#8ECAE6"
                                />
                                <path
                                  d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                  fill="white"
                                />
                              </svg>
                              NuForge - Grow faster with access to premium
                              listings and tools
                            </li>
                            <li className="ct_fs_14 ct_darkblue_text mt-2 d-flex align-items-center gap-2">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                  fill="#8ECAE6"
                                />
                                <path
                                  d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                  fill="white"
                                />
                              </svg>
                              NuStar - Stand out with early job invites, brand
                              support and pro-level exposure
                            </li>
                          </ul>
                          <div className="mt-4  text-center">
                            <button className="ct_yellow_btn mx-auto ct_sky_blue_btn ct_px_60">
                              Explore Plans
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {/* </div> */}

        <div
          className="modal modal-lg ct_congratulation_modal_fade"
          id="ct_add_experience_modal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h4 className="ct_fs_16 ct_darkblue_text mb-0">
                  Add Experience
                </h4>
                <button
                  type="button"
                  className="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body px-0 ct_mt_20 pt-0">
                <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Job Title
                        </label>
                        <input
                          type="text"
                          className="form-control ct_fs_12 ct_input"
                          placeholder=" Job title"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Company Name
                        </label>
                        <input
                          type="text"
                          className="form-control ct_fs_12 ct_input"
                          placeholder=" Company name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Project Duration
                        </label>
                        <input
                          type="date"
                          className="form-control ct_fs_12 ct_input"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Project Category
                        </label>
                        <select className="form-control ct_fs_12 ct_input">
                          <option>Project Category</option>
                          <option>Project Category</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Project Description
                        </label>
                        <textarea
                          className="form-control ct_input h-auto ct_fs_12"
                          rows={4}
                          placeholder="Briefly describe what you worked on, your responsibilities, and the outcome(max 400 characters)"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Upload Project Image (2 max)
                        </label>
                        <div
                          class="ct_upload_product_main ct_upload_product_main_180 "
                          style={{ height: "118px" }}
                        >
                          <svg
                            width="33"
                            height="33"
                            viewBox="0 0 33 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                              stroke="#9CA3AF"
                              stroke-width="2.66667"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>

                          <p class="text-center ct_fs_12 ct_text_op_07 mb-0">
                            Upload your project image here
                          </p>
                          <label for="ct_upload_product">
                            <input
                              type="file"
                              name=""
                              id="ct_upload_product"
                              class="d-none"
                            />
                          </label>
                        </div>

                        <div class="ct_single_uploaded_img mt-3 d-none">
                          <img
                            src="assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                            alt=""
                          />
                          <i class="fa-solid fa-xmark"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                    <button
                      className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2"
                      style={{ borderColorL: "#53586252" }}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className=" ct_yellow_btn px-5 ct_fs_14 py-2"
                      type="button"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </CoachMenuLayout>
    </>
  );
};

export default Profile;
